<template>
  <div class="project_style_qja_a_this">
    <basic-container>
      <div class="form_wrapper">
        <div class="form_header">
          <div class="form_header_name">{{ title }}</div>
          <!-- <div class="form_header_remarks">
            保存时带<span class="red_color">* </span
            >栏可以填写不完全，提交审核时带<span class="red_color">* </span
            >栏需填写完全 
          </div> -->
        </div>
        <div class="form_content">
          <avue-form
            :option="option"
            ref="form"
            v-model="form"
            :rules="rules"
            @submit="handleSubmit"
          >
            <!-- <template slot="group1Header">
              <div class="label_name">基础信息</div>
            </template>
            <template slot="group2Header">
              <div class="label_name">贷款到期金额明细</div>
            </template>
            <template slot="group3Header">
              <div class="label_name">财务信息</div>
            </template> -->
            <template slot="custId">
              <el-select
                filterable 
                v-model="form.custName"
                placeholder="请选择"
                value-key="id"
                @change="changeCustName"
              >
                <el-option
                  v-for="item in basicList"
                  :key="item.id"
                  :label="item.custName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </template>
            <template slot="bankName">
              <el-select
                v-model="form.bankName"
                placeholder="请选择"
                value-key="id"
                @change="changeBankName"
              >
                <el-option
                  v-for="item in bankList"
                  :key="item.id"
                  :label="item.bankName"
                  :value="item"
                >
                </el-option>
              </el-select>
            </template>
            <template slot="quota">
              <el-form-item
                label=""
                prop="quota"
                :rules="[
                  {
                    trigger: 'blue',
                    type: 'number',
                    min: 1,
                    message: '申请转贷金额必须是数字,且必须大于0',
                  },
                  {
                    validator: validatePass,
                    trigger: 'blue',
                    message: '申请转贷金额小于等于贷款到期金额',
                  },
                ]"
              >
                <el-input v-model.number="form.quota" autocomplete="off"
                  ><template slot="append">元</template></el-input
                >
              </el-form-item>
            </template>
            <template slot="expectUseDay">
              <el-form-item
                label=""
                prop="expectUseDay"
              >
              
                <el-input  v-model.number="form.expectUseDay"  autocomplete="off"
                  ><template slot="append">天</template></el-input
                >
              </el-form-item>
            </template>
            <!-- <template slot="projectDetail">
              <TableCustom ref="tableCustom" :tableData="tableData" />
            </template> -->
            <!-- <template slot="menuForm">
              <el-button
                type="primary"
                icon="el-icon-check"
                size="small"
                :loading="loading"
                @click="btnSave"
              >保存</el-button>
            </template> -->
          </avue-form>
        </div>
      </div>

      <Accessory
        v-if="uploadPermissionNameOne != ''"
        :idname="uploadPermissionNameTwo"
        :fileMenuUrlname="uploadPermissionNameOne"
        :projectid="id"
        :batchFileUpload="true"
        :upload="true"
        :permissionList="permissionList"
        :isPermission="true"
      />

      <InfoContainer
          style="margin-top: 20px;"
          :infoTitle="commentConfig['infoTitle']"
          :contentConfig="commentConfig['infoContent']"
      >
          <template #commentInfo>
              <!-- 会签意见区 -->
              <CommentBlock ref="commentBlock" :id="id" @fileChange="fileChange"/>
          </template>
      </InfoContainer>

      <div style="width: 100%;height: 40px;"></div>
      <div class="bottom-container">
          <div class="button-container">
              <el-button type="primary" @click="savePage(false)">保存</el-button>
              <!-- <el-button type="primary" plain @click="savePage(true)">发起流程</el-button> -->
          </div>
      </div>
    </basic-container>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="false"
      :clear="false"
      @setPeople="setPeople"
    />
  </div>
</template>

<script>
import * as api from "@/api/zd/project";
import { basicInformations } from "@/api/zd/visit";

import { mapGetters } from "vuex";
import InfoContainer from "@/components/infoContainer/infoContainer";
import Accessory from "@/components/accessoriesother/accessory"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock"
import SelectPerson from "@/components/SelectPersonnel/person";
import TableCustom from "./components/tableCustom";
import workFlow from "@/mixins/workFlow";
export default {
  name: "project",
  mixins: [workFlow],
  data() {
    return {
      form: {},
      processKey: 'process_zd_project_manage',
      detailFormUrl: '/zd/project/detail',
      option: {
        labelWidth: 120,
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "客户名称",
            prop: "custId",
            type: "select",
            formslot: true,
            dicData: [],
            dataType: "number",
            rules: [
              {
                required: true,
                trigger: "blur",
              },
            ],
          },
          {
            label: "客户类型",
            prop: "custType",
            placeholder: "等待生成客户类型",
            disabled: true,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=cust_type",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            rules: [
              {
                required: true,
                trigger: "blur",
              },
            ],
          },
          {
            label: "申请银行",
            prop: "bankName",
            formslot: true,
            type: "select",
            dicData: [],
            dataType: "number",
            rules: [
              {
                required: true,
                trigger: "blur",
              },
            ],
          },
          {
            label: "客户经理",
            prop: "managerName",
            placeholder: "等待生成客户经理",
            disabled: true,
            rules: [
              {
                required: true,
                trigger: "blur",
              },
            ],
          },
          {
            label: "贷款到期金额",
            prop: "expireQuota",
            placeholder: "表单总金额",
            // disabled: true,
            dataType: "number",
            rules: [
              {
                required: true,
                trigger: "blur",
                message: "请输入贷款到期金额",
              },
            ],
            formatter: (row, value, label, column) => {
              return this.getMoney(value);
            },
          },
          {
            label: "项目名称",
            prop: "name",
            placeholder: "等待生成项目名称",
            disabled: true,
            rules: [
              {
                required: true,
                trigger: "blur",
                message: "请补全表单数据",
              },
            ],
          },
          {
            label: "申请转贷金额",
            prop: "quota",
            append: "元",
            formslot: true,
            dataType: "number",
            rules: [
              {
                required: true,
                message: "请输入申请转贷金额",
                trigger: "blur",
              },
            ],
            controls: false,
            formatter: (row, value, label, column) => {
              return this.getMoney(value);
            },
          },
          {
            label: "预计出款时间",
            prop: "expectPayDate",
            type: "date",
            clearable: false,
            rules: [
              {
                required: true,
                message: "请选择预计出款时间",
                trigger: "blur",
              },
            ],
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
          },
          {
            label: "预计使用天数",
            prop: "expectUseDay",
            formslot: true,
            append: "天",
            rules: [
              {
                message: "请输入预计使用天数且天数必须大于0",
                required: true,
                trigger: "blur",
              },
            ],
            
          },
          {
            label: "使用费率",
            prop: "loanRate",
            slot: true,
            type: "select",
            dicUrl: "/api/blade-/zd/interestrate/dictionary",
            dicMethod: "get",
            dicQuery: {},
            clearable: false,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            rules: [
              {
                required: true,
                message: "请选择使用费率",
                trigger: "blur",
              },
            ],
          },
          {
            label: "开户行",
            prop: "payOpeningBank",
            placeholder: "等待生成开户行",
            disabled: true,
            rules: [
              {
                required: true,
                trigger: "blur",
              },
            ],
          },
          {
            label: "合作银行户名",
            prop: "payAccountName",
            placeholder: "等待生成开户行",
            disabled: true,
            rules: [
              {
                message: "请补全表单数据",
                required: true,
                trigger: "blur",
              },
            ],
          },
          {
            label: "合作银行账号",
            prop: "payBankAccount",
            placeholder: "等待生成开户行",
            disabled: true,
            rules: [
              {
                message: "请补全表单数据",
                required: true,
                trigger: "blur",
              },
            ],
          },{
            label: "是否需要总经理审批",
            prop: "managerAudit",
            placeholder: "请选择是否需要总经理审批",
            disabled: false,
            labelWidth: 160,
            type: 'select',
            value: 0,
            dicData:[{
              label:'否',
              value:0
            },{
              label:'是',
              value:1
            }],
            rules: [
              {
                message: "请选择是否需要总经理审批",
                required: true,
                trigger: "change",
              },
            ],
          },{
            label: "是否国企",
            prop: "isSoe",
            value:'0',
            placeholder: "请选择是否国企",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_gov",
            props: {
              label: "dictValue",
              value: "dictKey",
            },         
            disabled: false,
            type: 'select',
            rules: [
              {
                message: "请选择是否国企",
                required: true,
                trigger: "change",
              },
            ],
          },{
            label: '备注',
            prop: "remark",
            span: 24,
            value: '贷款到期明细详见附件',
            disabled: false,
            placeholder: "请输入备注"          
          }
        ]
      },
      id: -1,
      tableData: [],
      bankList: [],
      basicList: [], //客户名称 列表
      rules: {},
      loading: false,
    };
  },

  components: {
    Accessory,
    CommentBlock,
    InfoContainer,
    SelectPerson,
    TableCustom,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    title() {
      return this.$route.params.id > -1 ? "编辑项目" : "项目立项";
    },
    dateRange() {
      const { custId, custName, quota, expectPayDate } = this.form;
      return { custId, custName, quota, expectPayDate };
    },
  },
  watch: {
    dateRange: {
      handler(data) {
        this.$nextTick(() => {
          if (data.custId && data.quota && data.expectPayDate) {
            this.form.name =
              data.custName + " " + data.quota + " " + data.expectPayDate;
          } else {
            this.form.name = "";
          }
        });
      },
      deep: true,
    },
    tableData: {
      handler: function (data) {
        let expireQuota = "";

        data.map((item) => {
          if (item.amount && item.expireDate) {
            expireQuota =
              parseFloat(expireQuota || 0) + parseFloat(item.amount);
          }
        });
        this.form.expireQuota = expireQuota;
      },
      deep: true,
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    if (this.$route.params.id > -1) {
      this.getInfo();
    }else {
      this.id = await this.getVirtualID()
      this.form.managerName = this.userInfo.user_name
      this.form.managerUser = this.userInfo.user_id
      
    }
    this.getListDefault();
    this.basicInformations();
    this.getBasicConfigData()
  },

  methods: {
    getInfo() {
      api
        .info({
          id: this.id,
        })
        .then((res) => {
          let form = res.data.data;

          form.loanRate = form.loanRate > -1 ? form.loanRate : null;
          form.expectUseDay=form.expectUseDay > -1 ? form.expectUseDay : null;
          
          form.quota = parseFloat(form.quota);
          form.isSoe = `${form.isSoe}`
          form.reamrk = form.remark?form.remark: ''
          this.form = form;
          // 
          // this.tableData = form.projectDetail;
        })
        .catch((res) => {
          
        });
    },
    //客户名称列表
    basicInformations() {
      basicInformations({}).then((res) => {
        // const column = this.findObject(this.option.group, "custId");
        // column.dicData = res.data.data.map((item) => {
        //   return {
        //     label: item.custName,
        //     value: item.id,
        //   };
        // });
        this.basicList = res.data.data;
      });
    },
    //申请银行列表
    getListDefault() {
      api.getListDefault({ bankState: 1 }).then((res) => {
        // const column = this.findObject(this.option.group, "bankId");

        // column.dicData = res.data.data.map((item) => {
        //   return {
        //     label: item.bankName,
        //     value: item.id,

        //   };
        // });
        this.bankList = res.data.data;
      });
    },

    async getBasicConfigData() {
        this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
        // 获取当前流程文件上传列表权限 permissionList
        this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
        // 设置流程表单路径
        this.queryProcessFormDetail(this.processDefinedId)
    },

    // 会签意见区附件设置
    fileChange(fileList) {
        let self = this
        if(fileList.length > 0) {
            this.attchmentList = []
            fileList.map(item => {
                self.attchmentList.push({
                    name: item.name,
                    url: item.response.data.link
                })
            })
        }
    },

    //提交
    handleSubmit(form, done, loading) {
      this.$refs.form.validate((vaild) => {
        if (vaild) {
          let data = {};
          api.submitVisit(data).then(
            (res) => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              done();

              this.$refs.form.resetForm();
              this.$router.push({
                path: `/zd/project/detail/${res.data.data.id}`,
              });
            },
            (error) => {
              loading();
              
            }
          );
        }
      });
    },
    
    savePage(startProcess) {
      this.loading = true;
      let self = this
      if (!this.form.custId) {
        this.$message({
          message: "请选择客户名称",
          type: "warning",
        });
        this.loading = false;
        return;
      }
      // validator: validatePass2
      this.$refs.form.validate((valid) => {
        if(valid) {
          self.submitForm(startProcess)
        }
      })
    },

    async submitForm(startProcess) {
      let params = {
        custId: this.form.custId>-1?this.form.custId:undefined,
        custType: this.form.custType || "",
        bankId: this.form.bankId>-1?this.form.bankId:undefined,
        managerUser: this.form.managerUser || this.userInfo.user_id || '',
        expireQuota: this.form.expireQuota || "",
        name: this.form.name || "",
        // projectDetail: projectDetail || "",
        quota: this.form.quota || "",
        expectPayDate: this.form.expectPayDate || "",
        expectUseDay: this.form.expectUseDay || "",
        loanRate: this.form.loanRate || "",
        payOpeningBank: this.form.payOpeningBank || "",
        payAccountName: this.form.payAccountName || "",
        payBankAccount: this.form.payBankAccount || "",
        managerAudit: this.form.managerAudit || 0,
        id: this.id,
        isSoe: this.form.isSoe,
        remark: this.form.remark
      };

      let redirectInfo ={
          url: this.detailFormUrl,
          id: this.id
      }
      let processInsId = ''
      if(startProcess) {

          // let processNameRes = await getPocessName(params) 
          let processParams = {
              detailFormUrl:  JSON.stringify(redirectInfo),
              processId: this.processDefinedId,
              comment: this.$refs.commentBlock.$data.opinionContent,
              attachmentList: this.attchmentList,
              processInstanceName: `${this.form.projectName}合同结清流程`,
              managerAudit: this.form.managerAudit
          }
          processInsId = await this.startWorkFlowProcess(processParams)
          // params.flowableId = processInsId
      }

      let redirectInfos ={
          url: '/zd/project/flows',
          id: processInsId
      }

      let batchParams = {
        detailFormUrl: JSON.stringify(redirectInfos),
        flowableId: processInsId,
        batchIds: [this.id],
        batchNames: [this.form.name],
        fileMenuName: this.uploadPermissionNameTwo,
        fileMenuUrlName: this.uploadPermissionNameOne,
        remark: ''
      }

      let self = this
      await api.submit(params).then(res => {
        if(res.data.code == 200){
          if(startProcess) {
            // 调取批量审批接口
            api.submitBatch(batchParams).then(batchRes => {
              if(batchRes.data.code == 200 ) {
                self.$router.push({
                  path: `/zd/project/detail/${res.data.data.id}`,
                });
                // 跳转到详情页
                self.$message({
                    message: '保存成功',
                    type: 'success'
                })
              }
            })
          }else {
            self.$router.push({
              path: `/zd/project/detail/${res.data.data.id}`,
            });
            // 跳转到详情页
            self.$message({
                message: '保存成功',
                type: 'success'
            })            
          }

        }
      })
    },
    // 规则
    validatePass(rule, value, callback) {
      if (value > this.form.expireQuota) {
        callback(new Error("申请转贷金额小于等于贷款到期金额"));
      }else {
        callback();
      }
    },
    //选择了客户名称 的各种数据回填
    changeCustName(data) {
      this.form.custId = data.id;
      this.form.custName = data.custName;
      this.form.custType = data.custType;
      // this.form.managerName = data.businessManage || "-";
      // this.form.managerUser = data.businessManagerId;
    },
    //选择了申请银行 的各种数据回填
    changeBankName(data) {
      this.form.bankId = data.id;
      this.form.bankName = data.bankName;
      this.form.payOpeningBank = data.bankName;
      this.form.payAccountName = data.bankAccountName;
      this.form.payBankAccount = data.bankAccount;
    },
  },
};
</script>

<style lang="scss" scoped>
.form_wrapper {
  height: 100%;

  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;
  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;

    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }
}
.btn_save {
  text-align: center;
}
/deep/.approval_style_qja_a_this .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
  margin-bottom: 0px !important;
}
/deep/ .approval_style_qja_a_this .el-col.el-col-24.el-col-xs-24.el-col-sm-12.el-col-md-24.avue-form__menu.avue-form__menu--center{
    height: 0;
    margin: 0;
    padding: 0;
}
    .bottom-container{
        width: 100%;
        height: 70px;
        position: fixed;
        // z-index: 1000;
        bottom: 0px;
        left: 0px;
        z-index: 1000;
        background-color: #fff;
        box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
        .button-container{
            width: 78%;
            height: 100%;
            margin: 0 auto;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
    }
</style>

<style>
.approval_style_qja_a_this .el-card.is-always-shadow {
  background-color: #f0f2f5;
}

.approval_style_qja_a_this .avue-group {
  pointer-events: none;
}
.approval_style_qja_a_this .el-collapse-item__wrap {
  pointer-events: all;
}
</style>
